import { provide, computed, onUnmounted } from '@vue/composition-api'

export default function usetripDetails(ctx) {
  const tripId = ctx.root.$route.params.id
  ctx.root.$store.commit('trips/SET_TRIP_DETAILS_ID', tripId)

  const tripTriggers = computed(() => ctx.root.$store.getters['trips/getTripActions'])
  const tripDetails = computed(() => ctx.root.$store.getters['trips/getTripDetails'])
  const tripInfoLoading = computed(() => ctx.root.$store.getters['trips/getTripInfoLoading'])
  const tripBillDetails = computed(() => ctx.root.$store.getters['trips/getTripBillDetails'])
  const driverLocation = computed(() => ctx.root.$store.getters['trips/getDriverLocation'])

  const getTripPath = async () => {
    await ctx.root.$store.dispatch('trips/fetchTripPath')
  }
  const tripPath = computed(() => ctx.root.$store.getters['trips/getTripPath'])
  const fetchTripDetails = async () => {
    await ctx.root.$store.dispatch('trips/fetchTripDetails')
  }

  const fetchTripData = async () => {
    await fetchTripDetails()
  }

  fetchTripData()
  provide('trip', tripDetails)
  provide('tripInfoLoading', tripInfoLoading)
  onUnmounted(() => {
    ctx.root.$store.commit('trips/RESET_TRIP_INFORMATION')
  })

  const isScheduledRide = computed(() => {
    if (tripDetails.value) {
      const temp = tripDetails.value?.metadata?.booking
      if (temp) {
        return !!Object.keys(temp).length
      }
      return false
    }
    return false
  })

  const openBookingDetails = () => {
    window.open(`/bookings/${tripDetails.value.metadata.booking.id}`)
  }

  return {
    tripDetails,
    tripTriggers,
    tripPath,
    openBookingDetails,
    isScheduledRide,
    tripInfoLoading,
    getTripPath,
    fetchTripData,
    driverLocation,
    tripBillDetails,
  }
}
